import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Quote } from '../types/quote';
import { put } from '../lib/api';

export const useQuotesUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (quote: Quote) => {
      return put<Quote>(`/quotes-api/${quote.id}`, quote);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
    },
  });
}; 